import * as Yup from 'yup'
import { Form, Col, Row } from 'react-bootstrap'
import { CustomFormControl,Textarea } from '../../../../StyledComponents';
import { checkText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({

});

export const OtherInformationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors } = props;
    return (
        <>
                
                <Form.Group className="mb-3"  controlId="formAdditionalNotes">
                    <Form.Label>Möchtest Du uns noch etwas mitteilen?</Form.Label>
                    <CustomFormControl
                    as={Textarea} rows="3" pattern="/^[a-zA-Z0-9äöüÄÖÜßé '.,!?&_/\-()]+$/i"
                    colors={colors}
                    placeholder="Möchtest Du uns noch etwas mitteilen?"
                    type="text"
                    name="additionalNotes"
                    value={values.additionalNotes}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.additionalNotes && !errors.additionalNotes}
                    isInvalid={touched.additionalNotes && errors.additionalNotes}
                    maxLength={20000}
                />
                 <Form.Control.Feedback type="invalid">
                    {errors.additionalNotes}
                </Form.Control.Feedback>
                </Form.Group>
        </>
    );
};